// admin/DistrictDashboard.js
import React from 'react';

const DistrictDashboard = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>District Administration Dashboard</h1>
      <p>Welcome to District Admin Dashboard - District-level management</p>
    </div>
  );
};

export default DistrictDashboard;